import Image from 'app/Components/Shared/Image/image';
import React, { useState, useEffect, useRef, useCallback } from 'react';
import { Swiper, SwiperSlide } from 'swiper/react';
import SwiperCore, { Navigation, Pagination, Scrollbar, A11y } from 'swiper';
import Config from '../../../Config';
import { prepareUrl } from '../../../utilities/StringHelpers/StringHelpers.js';
import { gaEvent } from '../../../utilities/analytics/tracking';

const Benefit = (props) => {

    return (
        <>
            <div className='benefit-block-title' id={props.iContent.idToScroll?.value}>{props.iContent.title?.value}</div>
            <div className='benefit-block-items'>
                {props.iContent.benefitsList.expandedValue?.map((item, index) => (
                    <div className='benefit-block-item' key={index}>
                        <div className='benefit-block-image'>
                            <Image src={Config.epiBaseUrl + item.image.value?.url} />
                        </div>
                        <div className='benefit-block-details'>
                            {item.benefitsBoolList.expandedValue?.map((bool, index) => (
                                <div className='benefit-block-details-bools' key={index}>
                                    <span className='benefit-block-details-bools-icon'><Image src={Config.epiBaseUrl + bool.iconImage.expandedValue?.url} /></span>
                                    <span className='benefit-block-details-bools-title'>{bool.title?.value}</span>

                                </div>
                            ))}
                        </div>
                    </div>
                ))}
            </div>
        </>
    );
};
export default Benefit;
